import React, { Component } from 'react';
import { Form } from 'informed';
import axios from 'axios';
import { API_HOST } from '../../consts';
import InputSelect from '../../components/inputs/InputSelect';
import InputNumber from '../../components/inputs/InputNumber';
import { toast } from 'react-toastify';
import { Nav, NavItem, NavLink, Modal, ModalBody } from 'reactstrap';
import classnames from 'classnames';
import { withTheme } from 'styled-components';
import { get } from 'lodash';
import { Link } from 'react-router-dom';
import { InputTextArea } from '../../components/inputs';
import { Grid } from '@material-ui/core';
import LoadPaePage from '../../components/pae/LoadingBook';

class GPTFormPlan extends Component {
  state = {
    paramsFetch: {
      cursoId: '',
      codigoId: '',
      areaConhecimento_id: '',
      matriz_ref_id: '',
      periodo_id: '',
      habilidade_id: '',
      etapa_id: ''
    },
    loading: false
  };
  handleFilterChange = (filters) => {
    this.props.onFilterChange(filters);
  };
  state = {
    etapaOption: [],
    areaConhecimentoOption: [],
    componenteCurricularOption: [],
    habilidadeOption: [],
    periodoOptions: [],
    momentosOptions: [],
    booksOptions: [],
    capitulosOptions: [],
    metodologiaOptions: [],
    matrizReferenciaOption: [],
    typesofgenerators: 1,
    selectedAreaConhecimento: null,
    selectedComponenteCurricular: null,
    selectedPeriodo: null,
    recursosTecnologicosOptions: 'NAO',
    metodologiasAtivasOptions: 'SIM',
    paginaInicial: '',
    bookInfo: null,
    bookThumbnail: '',
    pdfUrl: '',
    isLoading: false,
    ano: null,
    prova: null,
    diretorioRegional: null,
    municipios: null,
    escola: null,
    serieEtapa: null,
    turma: null,
    periodo_id: null,
    ano_id: null,
    periodo_ano_id: null,
    selectTurma: null,
    apiInfo: {},
    typesofgeneratorsMap: [],
    checkApiStatus: false,
    apiResponseId: null,
    cd_etapa: '',
    edited: false,
    msg: [],
    response_id: null,
    momentsStatusList: []
  };

  convertMinutesToHour(value) {
    var hour = Math.floor(value / 60);
    var minutes = value % 60;

    var hourString = hour.toString().padStart(2, '0');
    var minutosString = minutes.toString().padStart(2, '0');

    return hourString + 'hrs e ' + minutosString + 'minutos';
  }

  componentDidMount() {
    this.fetchApiResponse();
  }

  fetchBooks = () => {
    const { paramsFetch, apiInfo } = this.state;
    axios
      .get(
        `${API_HOST}/openai/livro?area_conhecimento_id=${
          paramsFetch.area_id
        }&etapa_id=${paramsFetch.periodo_id}&habilidade_id=${get(
          apiInfo,
          'habilidade'
        )}`
      )
      .then((response) => {
        const options = response.data.map((response) => ({
          thumbnail: response.thumb,
          value: response.id,
          label: response.titulo
        }));

        this.setState({ booksOptions: options });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  fetchCapitulos = (id) => {
    const { apiInfo } = this.state;
    axios
      .get(
        `${API_HOST}/openai/capitulo?id_livro=${id && id}&habilidade_id=${get(
          apiInfo,
          'habilidade'
        )}`
      )
      .then((response) => {
        const options = response.data.map((response) => ({
          value: response.id,
          label: response.nome
        }));

        this.setState({ capitulosOptions: options });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  fetchMetodologias = () => {
    axios
      .get(`${API_HOST}/openai/metodologia`)
      .then((response) => {
        const options = response.data.map((response) => ({
          value: response.id,
          label: response.metodologia
        }));

        this.setState({ metodologiaOptions: options });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  etapaEscolaData = (d) => ({
    value: d.etapa_id,
    idn: d.idn,
    label: d.dc_etapa,
    ...d
  });

  fetchSerie = () => {
    axios
      .get(`${API_HOST}/avalia/escola_etapa`)
      .then((res) => {
        const data = res.data.results.map(this.etapaEscolaData);
        this.setState({ serieEtapa: data });
      })
      .catch((err) => {
        toast.error(err);
      });
  };

  fetchMe() {
    const token = localStorage.getItem('token');
    axios
      .get(`${API_HOST}/login/me`, {
        headers: {
          Authorization: `JWT ${token}`
        }
      })
      .then((response) => {
        this.setState({ me: response.data });
      })
      .catch((response) => toast.error(response.error));
  }

  fetchNivel = () => {
    axios.get(`${API_HOST}/core/periodo`).then((response) => {
      const options = [];

      response.data.map((mapResponse) => {
        if (mapResponse.etapa_nr) {
          options.push({
            value: mapResponse.id,
            label: mapResponse.descricao,
            codigo: mapResponse.etapa_nr,
            nivel: mapResponse.nivel_id
          });
        }
      });
      this.setState({ periodoOptions: options });
    });
  };

  fetchAreasConhecimento() {
    axios.get(`${API_HOST}/core/area_conhecimento`).then((response) => {
      const options = response.data.map((item) => ({
        value: item.id,
        label: item.descricao
      }));
      this.setState({ areaConhecimentoOption: options });
    });
  }

  fetchComponentesCurriculares() {
    axios.get(`${API_HOST}/core/componente_curricular`).then((response) => {
      const options = response.data.map((mapResponse) => ({
        value: mapResponse.id,
        label: mapResponse.descricao
      }));
      this.setState({ componenteCurricularOption: options });
    });
  }

  fetchMatrizReferencia() {
    const { paramsFetch } = this.state;
    if (paramsFetch) {
      const params = {
        status: 1,
        curso__id: paramsFetch.codigoId,
        areas_conhecimento__id: paramsFetch.area_id,
        etapa_id: paramsFetch.etapa_id
      };
      axios
        .get(`${API_HOST}/matriz_referencia/matriz_referencia`, { params })
        .then((response) => {
          const options = response.data.map((x) => ({
            value: x.id,
            label: x.descricao
          }));
          this.setState({ matrizReferenciaOption: options });
        })
        .catch((error) => console.error(error));
    }
  }

  fetchHabilidade() {
    const { paramsFetch, cd_etapa } = this.state;

    if (paramsFetch) {
      const params = {
        area_conhecimento_id: paramsFetch.area_id,
        matriz_id: paramsFetch.matriz_id,
        etapa_id: cd_etapa
      };
      axios
        .get(`${API_HOST}/matriz_referencia/habilidade`, { params })
        .then((response) => {
          const options = response.data.results.map((x) => ({
            value: x.id,
            label: `${x.cd_habilidade} - ${x.ds_habilidade}`
          }));
          this.setState({ habilidadeOption: options });
        })
        .catch((error) => console.error(error));
    }
  }

  fetchtypesofgenerators() {
    axios.get(`${API_HOST}/openai/typesofgenerators`).then((response) => {
      this.setState({ typesofgeneratorsMap: response.data });
    });
  }

  componentDidMount() {
    this.fetchMe();
    this.fetchSerie();
    this.fetchAreasConhecimento();
    this.fetchComponentesCurriculares();
    this.fetchNivel();
    this.fetchMetodologias();
    this.fetchMatrizReferencia();
    this.fetchtypesofgenerators();
  }

  componentDidUpdate(prevPops, prevState) {
    if (prevState.paramsFetch !== this.state.paramsFetch) {
      this.fetchMatrizReferencia();
      if (this.state.paramsFetch.matriz_id) {
        this.fetchHabilidade();
      }
      if (this.state.paramsFetch.habilidade_id) {
        this.fetchBooks();
      }
    }

    if (this.state.checkApiStatus) {
      this.fetchCheckApiResponse(this.state.response_id);
    }
  }

  sleep(delay = 0) {
    return new Promise((resolve) => {
      setTimeout(resolve, delay);
    });
  }

  fetchCheckApiResponse = async (apiResponseId) => {
    const { history } = this.props;
    await this.sleep(5e3);

    await axios

      .get(
        `${API_HOST}/openai/api-response/${apiResponseId}/class_plan_moment_status`
      )
      .then((res) => {
        this.setState({
          momentsStatusList: res.data.moments_status,
          checkApiStatus: true ? !res.data.every_moments_ready : false
        });
        if (res.data.every_moments_ready) {
          history.replace(`/assistente-pessoal-retorno/${res.data.id}`);
        }
      })
      .catch((err) => {
        this.setState({ isLoading: false });
        toast.error('Ocorreu um erro, Tente novamente.');
      });
  };

  formApiData = (editedvalue) => {
    const { values } = this.formApi.getState();
    const { typesofgenerators, edited, msg, response_id, paramsFetch } =
      this.state;

    const { recursosTecnologicosOptions } = this.state;
    const paramsValues = {
      ...values
    };

    if (get(values, 'duracao_aula')) {
      const duracaoAula = this.convertMinutesToHour(
        get(values, 'duracao_aula')
      );
      paramsValues['duracao_aula'] = duracaoAula;
    }

    let payload = [];

    payload.push(
      { type: typesofgenerators },
      {
        form: {
          values: {
            ...paramsValues,
            recursos_tec: recursosTecnologicosOptions,
            curso: paramsFetch.codigoId
          },
          recursosTecnologicosOptions
        }
      },
      // {
      //   form: {
      //     values: {
      //       ano: 1,
      //       prova: 1,
      //       dr: 18,
      //       Municipios: '5107206',
      //       Escolas: '1117673',
      //       periodo: 45,
      //       turma: '6032',
      //       area_conhecimento: 2,
      //       matriz_referencia: 10,
      //       duracao_aula: '02hrs e 00minutos',
      //       quantidade_de_momentos: '4',
      //       dinamica_grupo: '2',
      //       trabalho_casa: '2',
      //       perguntas_sobre_tema: '2',
      //       habilidade: 5462,
      //       observacao: 'teste',
      //       recursos_tec: 'NAO'
      //     },
      //     recursosTecnologicosOptions: 'NAO'
      //   }
      // },
      {
        msg: msg,
        edited: editedvalue ? editedvalue : edited,
        response_id: response_id
      }
    );

    this.setState({ isLoading: true });
    axios
      .post(`${API_HOST}/openai/api-response/request_api`, {
        payload
      })
      .then((response) => {
        if (response.data) {
          this.setState({ msg: response.data });
          this.setState({ response_id: response.data[0].api_response_id });
          // this.setState({ sended_to_queue: response.data[0].sended_to_queue });
          if (response.data[0].sended_to_queue) {
            this.fetchCheckApiResponse(response.data[0].api_response_id);
          }
        } else {
          this.fetchCheckApiResponse(response.data[0].api_response_id);
        }
      })
      .catch((error) => {
        // this.setState({ isLoading: false });
        toast.error('Ocorreu um erro, Tente novamente. nesse request');
      });
  };

  render() {
    const {
      isLoading,
      areaConhecimentoOption,
      ano,
      prova,
      dreOptions,
      municipios,
      escola,
      serieEtapa,
      msg,
      edited,
      periodoOptions,
      booksOptions,
      capitulosOptions,
      metodologiaOptions,
      paginaInicial,
      bookInfo,
      bookThumbnail,
      apiInfo,
      matrizReferenciaOption,
      turma,
      habilidadeOption,
      typesofgeneratorsMap,
      recursosTecnologicosOptions,
      momentsStatusList
    } = this.state;

    const showTab = true;
    if (showTab) {
      return (
        <>
          <div style={{ marginTop: '24px' }}>
            <div className="container mb-4 pb-4">
              <div className="row">
                <div className="col-12">
                  <div
                    className="card"
                    style={{ backgroundColor: '#f7f7f7', borderRadius: '10px' }}
                  >
                    <Nav
                      style={{
                        fontSize: '16px',
                        fontWeight: 600,
                        color: 'cyan',
                        borderRadius: '10px 10px 0px 0px',
                        backgroundColor: '#fff'
                      }}
                      tabs
                    >
                      {typesofgeneratorsMap.filter(
                        (values) => values.codigo === '5'
                      )[0] ? (
                        typesofgeneratorsMap.filter(
                          (values) => values.codigo === '5'
                        )[0].enabled ? (
                          <NavItem>
                            <Link to="/assistente-pessoal-form/inter">
                              <NavLink
                                className={classnames({
                                  active_tab: false
                                })}
                              >
                                {
                                  typesofgeneratorsMap.filter(
                                    (values) => values.codigo === '5'
                                  )[0].descricao
                                }
                              </NavLink>
                            </Link>
                          </NavItem>
                        ) : (
                          ''
                        )
                      ) : (
                        ''
                      )}
                      {typesofgeneratorsMap.filter(
                        (values) => values.codigo === '1'
                      )[0] ? (
                        typesofgeneratorsMap.filter(
                          (values) => values.codigo === '1'
                        )[0].enabled ? (
                          <NavItem>
                            <NavLink
                              className={classnames({
                                active_tab: true
                              })}
                            >
                              {
                                typesofgeneratorsMap.filter(
                                  (values) => values.codigo === '1'
                                )[0].descricao
                              }
                            </NavLink>
                          </NavItem>
                        ) : (
                          ''
                        )
                      ) : (
                        ''
                      )}

                      {typesofgeneratorsMap.filter(
                        (values) => values.codigo === '2'
                      )[0] ? (
                        typesofgeneratorsMap.filter(
                          (values) => values.codigo === '2'
                        )[0].enabled ? (
                          <NavItem>
                            <Link to="/assistente-pessoal-form/ind">
                              <NavLink
                                className={classnames({
                                  active: this.state.activeTab === 'dados'
                                })}
                              >
                                {
                                  typesofgeneratorsMap.filter(
                                    (values) => values.codigo === '2'
                                  )[0].descricao
                                }
                              </NavLink>
                            </Link>
                          </NavItem>
                        ) : (
                          ''
                        )
                      ) : (
                        ''
                      )}

                      {typesofgeneratorsMap.filter(
                        (values) => values.codigo === '3'
                      )[0] ? (
                        typesofgeneratorsMap.filter(
                          (values) => values.codigo === '3'
                        )[0].enabled ? (
                          <NavItem>
                            <Link to="/assistente-pessoal-form/group">
                              <NavLink
                                className={classnames({
                                  active:
                                    this.state.activeTab ===
                                    'matrizes_referencia'
                                })}
                              >
                                {
                                  typesofgeneratorsMap.filter(
                                    (values) => values.codigo === '3'
                                  )[0].descricao
                                }
                              </NavLink>
                            </Link>
                          </NavItem>
                        ) : (
                          ''
                        )
                      ) : (
                        ''
                      )}

                      {typesofgeneratorsMap.filter(
                        (values) => values.codigo === '4'
                      )[0] ? (
                        typesofgeneratorsMap.filter(
                          (values) => values.codigo === '4'
                        )[0].enabled ? (
                          <NavItem>
                            <Link to="/assistente-pessoal-form/indplan">
                              <NavLink
                                className={classnames({
                                  active: false
                                })}
                              >
                                {
                                  typesofgeneratorsMap.filter(
                                    (values) => values.codigo === '4'
                                  )[0].descricao
                                }
                              </NavLink>
                            </Link>
                          </NavItem>
                        ) : (
                          ''
                        )
                      ) : (
                        ''
                      )}
                    </Nav>
                    <div className="card-body">
                      <div style={{ marginBottom: '1.5rem' }}>
                        <span
                          style={{
                            color: '#333',
                            fontSize: '16px',
                            fontFamily: 'Quicksand',
                            fontWeight: 600
                          }}
                        >
                          Preencha os dados abaixo para que o sistema gere o
                          Plano de Aula
                        </span>
                      </div>
                      <Form
                        getApi={(formApi) => {
                          this.formApi = formApi;
                        }}
                      >
                        {({ formState }) => <div className="row"></div>}
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center'
                          }}
                        >
                          <Grid container spacing={2}>
                            <Grid item container xs={12}>
                              <Grid item xs={12} md={6}>
                                <label
                                  style={{
                                    color: '#333',
                                    fontFamily: 'Quicksand',
                                    fontSize: '14px',
                                    fontStyle: 'normal',
                                    fontWeight: 500,
                                    lineHeight: 'normal',
                                    marginBottom: '4px'
                                  }}
                                  htmlFor="Série/Ano"
                                >
                                  Etapa escolar
                                </label>
                                <InputSelect
                                  marginBottom="0px"
                                  key={serieEtapa}
                                  field="periodo"
                                  options={periodoOptions}
                                  onChange={(e) => {
                                    this.setState({
                                      apiInfo: {
                                        ...apiInfo,
                                        periodo: e && e.label
                                      },
                                      paramsFetch: {
                                        ...this.state.paramsFetch,
                                        codigoId: e && e.nivel,
                                        periodo_id: e && e.value,
                                        etapa_id: e && e.etapa_id
                                      }
                                    });
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <label
                                  style={{
                                    color: '#333',
                                    fontFamily: 'Quicksand',
                                    fontSize: '14px',
                                    fontStyle: 'normal',
                                    fontWeight: 500,
                                    lineHeight: 'normal',
                                    marginBottom: '4px'
                                  }}
                                  htmlFor="Área de conhecimento"
                                >
                                  Área do conhecimento
                                </label>
                                <InputSelect
                                  field="area_conhecimento"
                                  marginBottom="0px"
                                  onChange={(e) => {
                                    this.setState({
                                      apiInfo: {
                                        ...apiInfo,
                                        area: e && e.label,
                                        area_id: e && e.id
                                      },
                                      paramsFetch: {
                                        ...this.state.paramsFetch,
                                        area_id: e && e.value
                                      }
                                    });
                                  }}
                                  options={areaConhecimentoOption}
                                />
                              </Grid>
                            </Grid>

                            <Grid item container xs={12}>
                              <Grid item xs={12} md={6}>
                                <label
                                  style={{
                                    color: '#333',
                                    fontFamily: 'Quicksand',
                                    fontSize: '14px',
                                    fontStyle: 'normal',
                                    fontWeight: 500,
                                    lineHeight: 'normal',
                                    marginBottom: '4px'
                                  }}
                                  htmlFor="Matriz de referência"
                                >
                                  Matriz de referência
                                </label>
                                <InputSelect
                                  autoload
                                  marginBottom="0px"
                                  field="matriz_referencia"
                                  options={matrizReferenciaOption}
                                  onChange={(e) => {
                                    this.setState({
                                      apiInfo: {
                                        ...apiInfo,
                                        matriz: e && e.label
                                      },
                                      paramsFetch: {
                                        ...this.state.paramsFetch,
                                        matriz_id: e && e.value
                                      }
                                    });
                                  }}
                                />
                              </Grid>

                              <Grid item xs={12} md={6}>
                                <label
                                  style={{
                                    color: '#333',
                                    fontFamily: 'Quicksand',
                                    fontSize: '14px',
                                    fontStyle: 'normal',
                                    fontWeight: 500,
                                    lineHeight: 'normal',
                                    marginBottom: '4px'
                                  }}
                                  htmlFor="Habilidade"
                                >
                                  Habilidade
                                </label>
                                <InputSelect
                                  autoload
                                  marginBottom="0px"
                                  field="habilidade"
                                  options={habilidadeOption}
                                  onChange={(event) => {
                                    this.setState({
                                      apiInfo: {
                                        ...apiInfo,
                                        habilidade: event && event.value
                                      },
                                      paramsFetch: {
                                        ...this.state.paramsFetch,
                                        habilidade_id: event.value
                                      }
                                    });
                                  }}
                                />
                              </Grid>
                            </Grid>

                            <Grid item container xs={12}>
                              <Grid item xs={12} md={6}>
                                <label
                                  style={{
                                    color: '#333',
                                    fontFamily: 'Quicksand',
                                    fontSize: '14px',
                                    fontStyle: 'normal',
                                    fontWeight: 500,
                                    lineHeight: 'normal',
                                    marginBottom: '4px'
                                  }}
                                  htmlFor="Duração da Aula"
                                >
                                  Duração da aula (minutos)
                                </label>
                                <InputNumber
                                  style={{
                                    marginBottom: '-1rem',
                                    marginTop: '-1rem',
                                    width: '99%'
                                  }}
                                  field="duracao_aula"
                                  mask_="9"
                                />
                              </Grid>

                              <Grid item xs={12} md={6}>
                                <label
                                  style={{
                                    color: '#333',
                                    fontFamily: 'Quicksand',
                                    fontSize: '14px',
                                    fontStyle: 'normal',
                                    fontWeight: 500,
                                    lineHeight: 'normal',
                                    marginBottom: '4px'
                                  }}
                                  htmlFor="Duração da Aula"
                                >
                                  Quantidade de momentos
                                </label>
                                <InputNumber
                                  style={{
                                    marginBottom: '-1rem',
                                    marginTop: '-1rem',
                                    width: '99%'
                                  }}
                                  field="quantidade_de_momentos"
                                  mask_="9"
                                />
                              </Grid>
                            </Grid>

                            <Grid
                              item
                              container
                              xs={12}
                              style={{ marginBottom: '-1rem' }}
                            >
                              <Grid item xs={12} md={4}>
                                <label
                                  style={{
                                    color: '#333',
                                    fontFamily: 'Quicksand',
                                    fontSize: '14px',
                                    fontStyle: 'normal',
                                    fontWeight: 500,
                                    lineHeight: 'normal'
                                  }}
                                  htmlFor="Dinâmicas em grupo"
                                >
                                  Nº de dinâmicas em grupo
                                </label>
                                <InputNumber
                                  style={{
                                    marginBottom: '0px',
                                    marginTop: '-1rem',
                                    width: '98%'
                                  }}
                                  field="dinamica_grupo"
                                  mask_="9"
                                />
                              </Grid>

                              <Grid item xs={12} md={4}>
                                <label
                                  style={{
                                    color: '#333',
                                    fontFamily: 'Quicksand',
                                    fontSize: '14px',
                                    fontStyle: 'normal',
                                    fontWeight: 500,
                                    lineHeight: 'normal'
                                  }}
                                  htmlFor="Trabalhos de Casa"
                                >
                                  Nº de trabalhos de casa
                                </label>
                                <InputNumber
                                  style={{
                                    marginBottom: '0px',
                                    marginTop: '-1rem',
                                    width: '98%'
                                  }}
                                  field="trabalho_casa"
                                  mask_="9"
                                />
                              </Grid>

                              <Grid item xs={12} md={4}>
                                <label
                                  style={{
                                    color: '#333',
                                    fontFamily: 'Quicksand',
                                    fontSize: '14px',
                                    fontStyle: 'normal',
                                    fontWeight: 500,
                                    lineHeight: 'normal'
                                  }}
                                  htmlFor="Perguntas sobre o tema"
                                >
                                  Nº de perguntas sobre o tema
                                </label>
                                <InputNumber
                                  style={{
                                    marginBottom: '0px',
                                    marginTop: '-1rem',
                                    width: '98%'
                                  }}
                                  field="perguntas_sobre_tema"
                                  mask_="9"
                                />
                              </Grid>
                            </Grid>

                            <Grid
                              item
                              container
                              xs={12}
                              style={{ marginBottom: '-1rem' }}
                            >
                              <Grid item container xs={12} md={6}>
                                <Grid item xs={12}>
                                  <label
                                    style={{
                                      color: '#333',
                                      fontFamily: 'Quicksand',
                                      fontSize: '14px',
                                      fontStyle: 'normal',
                                      fontWeight: 500,
                                      lineHeight: 'normal',
                                      marginBottom: '4px'
                                    }}
                                    htmlFor="Livro"
                                  >
                                    Livro
                                  </label>
                                  <InputSelect
                                    autoload
                                    marginBottom="0px"
                                    field="livro"
                                    onChange={(event) => {
                                      this.fetchCapitulos(event && event.value);
                                      this.setState({
                                        bookInfo: get(event, 'value'),
                                        bookThumbnail: get(
                                          event,
                                          'thumbnail',
                                          ''
                                        ),
                                        pdfUrl: get(event, 'url', '')
                                      });
                                    }}
                                    options={booksOptions}
                                  />
                                </Grid>

                                <Grid item xs={12}>
                                  <label
                                    style={{
                                      color: '#333',
                                      fontFamily: 'Quicksand',
                                      fontSize: '14px',
                                      fontStyle: 'normal',
                                      fontWeight: 500,
                                      lineHeight: 'normal',
                                      marginBottom: '4px'
                                    }}
                                    htmlFor="Título do Capítulo"
                                  >
                                    Título do capítulo
                                  </label>
                                  <InputSelect
                                    autoload
                                    marginBottom="0px"
                                    field="capitulo"
                                    onChange={(event) => {}}
                                    options={capitulosOptions}
                                  />
                                </Grid>

                                <Grid item xs={12}>
                                  <label
                                    style={{
                                      color: '#333',
                                      fontFamily: 'Quicksand',
                                      fontSize: '14px',
                                      fontStyle: 'normal',
                                      fontWeight: 500,
                                      lineHeight: 'normal',
                                      marginBottom: '4px'
                                    }}
                                    htmlFor="metodologia"
                                  >
                                    Metodologia
                                  </label>
                                  <InputSelect
                                    autoload
                                    marginBottom="0px"
                                    field="metodologia"
                                    options={metodologiaOptions}
                                    onChange={(e) => {
                                      this.setState({
                                        apiInfo: {
                                          ...apiInfo,
                                          metodologia: e && e.value
                                        }
                                      });
                                    }}
                                  />
                                </Grid>
                              </Grid>

                              <Grid item container xs={12} md={6}>
                                <Grid item xs={12}>
                                  <div style={{ textAlign: 'center' }}>
                                    {bookInfo !== null && bookThumbnail ? (
                                      <img
                                        src={bookThumbnail}
                                        alt="image-book"
                                        width="250"
                                        style={{ borderRadius: '12px' }}
                                      />
                                    ) : null}
                                  </div>
                                </Grid>
                              </Grid>
                            </Grid>

                            <Grid
                              item
                              xs={12}
                              style={{ marginBottom: '-1rem' }}
                            >
                              <label
                                style={{
                                  color: '#333',
                                  fontFamily: 'Quicksand',
                                  fontSize: '14px',
                                  fontStyle: 'normal',
                                  fontWeight: 500,
                                  lineHeight: 'normal',
                                  marginBottom: '4px'
                                }}
                                htmlFor="Observacao"
                              >
                                O Plano deve abranger
                              </label>
                              <InputTextArea
                                style={{
                                  width: '98%',
                                  height: '12rem !important',
                                  marginBottom: '0px',
                                  marginTop: '-1rem'
                                }}
                                field="observacao"
                                // placeholder="
                                // 1. Localize e descreva os principais sistemas fluviais e discuta as configurações
                                //  físicas que apoiaram o assentamento permanente e as primeiras civilizações.
                                // 2. Discuta as principais características da arte e arquitetura egípcia.
                                // 3. Compreender a relação entre a religião e a ordem social e política na Mesopotâmia e no Egipto.
                                // 4. Conheça o significado do código de Hammurabi.
                                // 5. Descreva o papel do comércio egípcio no Mediterrâneo oriental e no vale do Nilo.
                                // 6. Entenda o significado da rainha Hatshepsut e de Ramsés, o Grande.
                                // 7. Identifique a localização da civilização Kush e descreva suas relações políticas,
                                //  comerciais e culturais com o Egito.
                                // 8. Acompanhe a evolução da linguagem e suas formas escritas
                                // "
                                onChange={(event) => {
                                  this.setState({
                                    apiInfo: {
                                      ...apiInfo,
                                      observacao: event.value
                                    }
                                  });
                                }}
                              />
                            </Grid>

                            <Grid item container xs={12}>
                              <Grid item xs={12} md={6}>
                                <label
                                  style={{
                                    color: '#333',
                                    fontFamily: 'Quicksand',
                                    fontSize: '14px',
                                    fontStyle: 'normal',
                                    fontWeight: 500,
                                    lineHeight: 'normal',
                                    marginBottom: '4px'
                                  }}
                                  htmlFor="Utilizar recursos tecnológicos na aula?"
                                >
                                  Utilizar recursos tecnológicos?
                                </label>
                                <label
                                  style={{
                                    marginBottom: '-1rem',
                                    display: 'flex'
                                  }}
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'center'
                                    }}
                                  >
                                    <input
                                      type="radio"
                                      value="SIM"
                                      onChange={(e) =>
                                        this.setState({
                                          recursosTecnologicosOptions:
                                            e.target.value
                                        })
                                      }
                                      checked={
                                        recursosTecnologicosOptions === 'SIM'
                                      }
                                    />
                                    <p
                                      style={{
                                        marginLeft: '0.2rem',
                                        marginTop: '1rem'
                                      }}
                                    >
                                      Sim
                                    </p>
                                  </div>

                                  <div
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'center',
                                      marginLeft: '2rem'
                                    }}
                                  >
                                    <input
                                      type="radio"
                                      value="NAO"
                                      onChange={(e) =>
                                        this.setState({
                                          recursosTecnologicosOptions:
                                            e.target.value
                                        })
                                      }
                                      checked={
                                        recursosTecnologicosOptions === 'NAO'
                                      }
                                    />
                                    <p
                                      style={{
                                        marginLeft: '0.2rem',
                                        marginTop: '1rem'
                                      }}
                                    >
                                      Não
                                    </p>
                                  </div>
                                </label>
                              </Grid>
                            </Grid>
                          </Grid>

                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'end',
                              marginTop: '1rem',
                              marginRight: '0px',
                              width: '98%'
                            }}
                          >
                            <button
                              style={{
                                color: 'white',
                                backgroundColor: this.props.theme.primary,
                                border: 'none',
                                fontSize: '1rem',
                                fontWeight: '600',
                                textAlign: 'center',
                                cursor: 'pointer',
                                borderRadius: '15px',
                                boxShadow: '2px 4px 5px rgba(58, 58, 58, 0.25)',
                                letterSpacing: '1px',
                                padding: '4px 16px',
                                display: 'flex',
                                justifyContent: 'center',
                                flexDirection: 'row',
                                alignItems: 'center'
                              }}
                              onClick={() => this.formApiData()}
                              disabled={isLoading}
                            >
                              Gerar Sugestão Pedagógica
                            </button>
                            <Modal
                              style={{
                                marginTop: '300px',
                                borderRadius: '20px',
                                overflow: 'hidden',
                                maxWidth: '35%'
                              }}
                              isOpen={isLoading}
                              toggle={this.toggle}
                            >
                              <ModalBody
                                style={{
                                  padding: '1.8rem',
                                  borderRadius: '10px',
                                  height: '1059px'
                                }}
                              >
                                <div style={{ textAlign: 'center' }}>
                                  {edited === true ? (
                                    <>
                                      <LoadPaePage
                                        momentsStatusList={momentsStatusList}
                                      />
                                    </>
                                  ) : (
                                    <>
                                      <div
                                        style={{
                                          position: 'relative',
                                          top: '-26px'
                                        }}
                                      >
                                        <svg
                                          width="659"
                                          height="11"
                                          viewBox="0 0 659 11"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M0 0H659C659 6.07513 654.075 11 648 11H11C4.92488 11 0 6.07513 0 0Z"
                                            fill={this.props.theme.primary}
                                          />
                                        </svg>
                                      </div>
                                      <svg
                                        width="79"
                                        height="61"
                                        viewBox="0 0 79 61"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M0 32H79V61H0V32Z"
                                          fill={this.props.theme.primary}
                                        />
                                        <path
                                          d="M27.5156 42C26.9531 42 26.4688 41.8125 26.0625 41.4375C25.6875 41.0312 25.5 40.5469 25.5 39.9844V33.6562C25.5 33.125 25.5938 32.625 25.7812 32.1562C26 31.6562 26.2969 31.2188 26.6719 30.8438L46.3125 11.1562L56.3438 21.1875L36.6562 40.8281C36.2812 41.2031 35.8438 41.5 35.3438 41.7188C34.875 41.9062 34.375 42 33.8438 42H27.5156ZM49.1719 8.34375L50.25 7.21875C51.0312 6.4375 51.9688 6.04688 53.0625 6.04688C54.1875 6.04688 55.1406 6.4375 55.9219 7.21875L60.2812 11.5781C61.0625 12.3594 61.4531 13.3125 61.4531 14.4375C61.4531 15.5313 61.0625 16.4688 60.2812 17.25L59.1562 18.3281L49.1719 8.34375Z"
                                          fill="black"
                                        />
                                      </svg>
                                      <h3
                                        style={{
                                          color: '#000',
                                          fontFamily: 'Public Sans',
                                          fontSize: '24px',
                                          fontWeight: 600,
                                          marginTop: '24px'
                                        }}
                                      >
                                        Parabéns, você está prestes a concluir
                                        seu{' '}
                                        <p
                                          style={{
                                            color: this.props.theme.primary,
                                            fontFamily: 'Public Sans',
                                            fontSize: '24px'
                                          }}
                                        >
                                          Plano de aula!
                                        </p>
                                      </h3>
                                      <div
                                        style={{
                                          width: '50%',
                                          position: 'relative',
                                          left: '25%',
                                          lineHeight: '16px'
                                        }}
                                      >
                                        <p
                                          style={{
                                            color: '#4A4F58',
                                            fontWeight: 500
                                          }}
                                        >
                                          Nesta etapa, você consegue revisar e
                                          editar as informações que você
                                          selecionou até agora, se estiver de
                                          acordo clique em "Tudo certo, vamos
                                          lá!"
                                        </p>
                                      </div>
                                      {msg &&
                                        msg.map((item, i) => (
                                          <textarea
                                            className="textarea"
                                            key={item.response_moment}
                                            style={{
                                              width: '100%',
                                              height: 'fit-content',
                                              minHeight: '30vh',
                                              maxHeight: '100%',
                                              resize: 'vertical',
                                              overflow: 'auto',
                                              borderRadius: '20px',
                                              borderColor: '#CFD2D9',
                                              color: '#4A4F58',
                                              padding: '25px'
                                            }}
                                            value={item.msg}
                                            onChange={(e) => {
                                              let newMsg = msg;
                                              newMsg[i].msg = e.target.value;

                                              this.setState({
                                                msg: newMsg
                                              });
                                            }}
                                          />
                                        ))}
                                      <button
                                        style={{
                                          marginTop: '10px',
                                          padding: '5px 10px',
                                          backgroundColor: 'white',
                                          color: this.props.theme.primary,
                                          border: 'none',
                                          borderRadius: '15px',
                                          cursor: 'pointer',
                                          position: 'relative',
                                          left: '31%',
                                          marginLeft: '5px',
                                          fontFamily: 'Public Sans',
                                          fontWeight: 'bold'
                                        }}
                                        onClick={() => {
                                          this.setState({ isLoading: false });
                                        }}
                                      >
                                        Cancelar
                                      </button>
                                      <button
                                        style={{
                                          marginTop: '10px',
                                          padding: '5px 10px',
                                          backgroundColor:
                                            this.props.theme.primary,
                                          color: '#fff',
                                          border: 'none',
                                          borderRadius: '15px',
                                          cursor: 'pointer',
                                          position: 'relative',
                                          left: '33%',
                                          fontFamily: 'Public Sans',
                                          fontWeight: 'bold'
                                        }}
                                        onClick={() => {
                                          this.setState({ edited: true });
                                          this.formApiData(true);
                                        }}
                                      >
                                        Tudo certo, vamos lá!
                                      </button>
                                    </>
                                  )}
                                </div>
                              </ModalBody>
                            </Modal>
                          </div>
                        </div>
                      </Form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      );
    }
  }
}

export default withTheme(GPTFormPlan);
